import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useRef } from 'react'
import { MdClose, MdPrint } from 'react-icons/md';
import { useReactToPrint } from 'react-to-print';

const PassengerInfo = ({ rows, handleClosePassengerInfoModal }) => {
  const contentToPrint = useRef(null);
  const handlePrint = useReactToPrint({
    documentTitle: "Print This Document",
    onBeforePrint: () => { },
    onAfterPrint: () => { },
    removeAfterPrint: true,
  });
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
        }}
      >
        <Tooltip title="بستن" placement="top">
          <IconButton onClick={handleClosePassengerInfoModal}>
            <MdClose style={{ color: '#4a148c' }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="چاپ" placement="top">
          <IconButton style={{ margin: '2px' }} onClick={() => {
            handlePrint(null, () => contentToPrint.current);
          }}>
            <MdPrint color='rgb(22, 95, 129)' />
          </IconButton>
        </Tooltip>
      </Box>
      <div ref={contentToPrint} dir='rtl' style={{ textAlign: 'center' }}>
        <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
          لیست زائران {rows[0]?.bedCountTitle} کاروان {rows[0]?.nameOfBroker} {rows[0]?.brokerCode}
        </Typography>
        <table border={1} cellSpacing={0} cellPadding={10} align='center' style={{ fontSize: '12px' }}>
          <thead style={{ background: '#eee' }}>
            <tr>
              <th>ردیف</th>
              <th>نام</th>
              <th>نام خانوادگی</th>
              <th>نام پدر</th>
              <th>کد ملی</th>
              <th>شماره گذر</th>
              <th>اتاق</th>
            </tr>
          </thead>
          <tbody>
            {
              rows?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.firstName}</td>
                  <td>{item.familyName}</td>
                  <td>{item.fatherName}</td>
                  <td>{item.ssn}</td>
                  <td>{item.passNo}</td>
                  <td>{item.bedCountTitle}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>

    </div>
  )
}

export default PassengerInfo